import React from "react";

export default function FundTransferHistoryTable({ details }) {
  return (
    <tr>
      <th scope="row">{details.accountId}</th>
      <td>{details.amount}</td>
      <td>{details.description}</td>
      <td>{details.status}</td>
      <td>{details.paymentType}</td>
      <td>{details.transferType}</td>
      <td>{details.createdAt}</td>
    </tr>
  );
}
